// HOOK OF INPUT
import { TextField }                    from '@material-ui/core';
import React, { Fragment, useState }    from 'react'

export default function useInput({ type,  initialState, maxLength, min, max, disabled, label, step, invalid }) {
    const   [value, setValue] = useState(initialState ? initialState : ""),
            input = (
                <Fragment >
                    <TextField
                        value       = { value? value: initialState }
                        onChange    = {({ target }) => setValue(target.value)}
                        type        = {type ? type : 'text'}
                        invalid     = {invalid}
                        maxRows     = {maxLength}
                        maxLength   = {maxLength ? maxLength : 255}
                        min         = {min}
                        max         = {max}
                        step        = {step ? step : 1}
                        disabled    = {disabled ? disabled : false}
                        fullWidth
                        InputLabelProps={{style:{background:'white',marginBottom:'0',fontSize: 14,paddingRight:'0', zIndex: '0'}}}
                        variant     = "outlined"
                        size        = "small"
                        label       = {label}
                        id          = "outlined-basic"
                        autoComplete= "on"
                        inputProps  ={type==="number"?{min, max,style: {fontSize: 12}}:{style: {fontSize: 12}}}
                    />
                </Fragment>
            )
    return {
        get: value,
        input,
        set: setValue,
    }
}